<template>
  <page>
    <div>
      <v-flex xs12>
        <form>
          <v-expansion-panels>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div><v-icon>mdi-filter-variant</v-icon> Filters</div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card>
                  <v-card-text>
                    <v-container fluid grid-list-lg>
                      <v-layout row wrap>
                        <v-flex xl3 lg6 xs6>
                          <v-text-field
                            v-model="filters.uom"
                            :label="labels.uom"
                            :error-messages="errors.collect('uom')"
                            data-vv-scope="filter"
                            data-vv-name="uom"
                            :data-vv-as="labels.uom"
                            v-validate="'max:4'"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xl3 lg6 xs6>
                          <v-text-field
                            v-model="filters.uomShortDesc"
                            :label="labels.uomShortDesc"
                            :error-messages="errors.collect('uomShortDesc')"
                            data-vv-scope="filter"
                            data-vv-name="uomShortDesc"
                            :data-vv-as="labels.uomShortDesc"
                            v-validate="'max:40'"
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                      <v-layout row wrap>
                        <v-flex xl3 lg12 xs12>
                          <v-text-field
                            v-model="filters.uomLongDesc"
                            :label="labels.uomLongDesc"
                            :error-messages="errors.collect('uomLongDesc')"
                            data-vv-scope="filter"
                            data-vv-name="uomLongDesc"
                            :data-vv-as="labels.uomLongDesc"
                            v-validate="'max:100'"
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                      <v-layout row wrap>
                        <v-flex xl3 lg6 xs6>
                          <v-checkbox
                            v-model="filters.isExcess"
                            :label="labels.isExcess"
                            :error-messages="errors.collect('isExcess')"
                            data-vv-scope="filter"
                            data-vv-name="isExcess"
                            :data-vv-as="labels.isExcess"
                            hide-details
                          ></v-checkbox>
                        </v-flex>
                        <v-flex xl3 lg6 xs6>
                          <v-checkbox
                            v-model="filters.isSumInsured"
                            :label="labels.isSumInsured"
                            :error-messages="errors.collect('isSumInsured')"
                            data-vv-scope="filter"
                            data-vv-name="isSumInsured"
                            :data-vv-as="labels.isSumInsured"
                            hide-details
                          ></v-checkbox>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="red darken-1" text @click.native="doClearFilters">Clear Filters</v-btn>
                    <v-btn color="primary" text type="submit" @click.prevent="doFilters">Apply Filters</v-btn>
                  </v-card-actions>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </form>
      </v-flex>
      <v-spacer class="mt-2"></v-spacer>
      <v-card>
        <v-flex xs12>
          <message :messages="messages"></message>
        </v-flex>
        <v-card-title>
          <v-spacer></v-spacer>
          <div class="pt-2">
            <v-btn color="primary" @click.native="doNew()">
              New Unit Of Measure
              <v-icon right>mdi-plus</v-icon>
            </v-btn>
          </div>
        </v-card-title>
        <v-flex>
          <v-card>
            <v-data-table
              :headers="headers"
              :items="items"
              v-bind:options.sync="pagination"
              :server-items-length="totalItems"
              :loading="loading"
              :footer-props="{'items-per-page-options': itemsPerPage }"
              :no-data-text="noDataText"
            >
              <template v-slot:item="row"
                ><tr>
                  <td>{{ row.item.uom }}</td>
                  <td class="text-xs-left">{{ row.item.uomShortDesc }}</td>
                  <td class="text-xs-left">{{ formatBoolean(row.item.isExcess) }}</td>
                  <td class="text-xs-left">{{ formatBoolean(row.item.isSumInsured) }}</td>
                  <td class="table-action-header">
                    <table-action
                      :rowData="row"
                      query
                      @query="doAction('query', row.item)"
                      review
                      @review="doAction('edit', row.item)"
                      remove
                      @remove="doRemoveValidation"
                    ></table-action>
                  </td></tr
              ></template>
            </v-data-table>
          </v-card>
        </v-flex>
      </v-card>
      <v-dialog v-model="uomReview" width="1100px" persistent>
        <uom-review :uomForm="uomForm" :mode="mode" @close="doClose"></uom-review>
      </v-dialog>
    </div>
  </page>
</template>

<script>
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import UomReview from './UOMReview'
import { expandURI, filterQuery } from '@/utils/ajax'

export default {
  data() {
    return {
      toogleArray: [false],
      headers: [
        { text: 'UOM', align: 'left', value: 'uom' },
        { text: 'Short Description', value: 'uomShortDesc' },
        { text: 'Is Excess', value: 'isExcess' },
        { text: 'Is Sum Insured', value: 'isSumInsured' },
        TableConst.tableActionHeader
      ],
      labels: {
        uom: 'UOM',
        uomShortDesc: 'Short Description',
        uomLongDesc: 'Long Description',
        isExcess: 'Is Excess',
        isSumInsured: 'Is Sum Insured'
      },
      filters: {
        uom: null,
        uomShortDesc: null,
        uomLongDesc: null,
        isExcess: null,
        isSumInsured: null
      },
      uomForm: {
        uom: null,
        uomShortDesc: null,
        uomLongDesc: null,
        isExcess: false,
        isSumInsured: false,
        createdName: '',
        createdDate: null,
        modifiedName: '',
        modifiedDate: null
      },
      totalItems: 0,
      mode: '',
      uomReview: false,
      loading: false,
      promptRemove: false,
      pagination: {
        sortDesc: [false],
        page: 1
      }
    }
  },
  watch: {
    // For pagination, we dont want to watch all the pagination property using deep (shown in vuetify eg)
    // This way the application will load multiple times at the start (when setting totalElements etc)
    'pagination': function (value) {
      this.doInit(false)
    }
  },
  computed: {
    uomMenu() {
      return this.$store.state.uomParam.menu
    }
  },
  methods: {
    async doInit(options) {
      const apiURI = this.uomMenu.getUOMList
      if (apiURI) {
        try {
          this.loading = true
          const { page, itemsPerPage } = this.pagination
          let expand = {
            page: page - 1,
            size: itemsPerPage,
            options: options
          }
          const result = await this.$http.get(filterQuery(expandURI(apiURI, expand), this.filters, this.pagination.sortBy, this.pagination.sortDesc))
          if (result) {
            this.totalItems = result.data.totalElements
            const { data } = result.data
            this.items = []
            if (data) {
              data.map((uom) => {
                const convertList = {
                  uom: uom.uom,
                  uomShortDesc: uom.uomShortDesc,
                  uomLongDesc: uom.uomLongDesc,
                  isExcess: uom.isExcess,
                  isSumInsured: uom.isSumInsured
                }
                this.items.push(convertList)
              })
            }
          }
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.loading = false
        }
      }
    },
    doClearFilters() {
      this.resetMessages()
      this.filters.uom = null
      this.filters.uomShortDesc = null
      this.filters.uomLongDesc = null
      this.filters.isExcess = null
      this.filters.isSumInsured = null
      this.pagination.page = 1
      this.doInit(false)
    },
    doFilters() {
      this.resetMessages()
      this.$validator.validateAll('filter').then((result) => {
        if (result) {
          this.pagination.page = 1
          this.doInit(false)
        }
      })
    },
    async doAction(mode, listData) {
      this.resetMessages()
      const apiURI = this.uomMenu.getUOM
      const expand = { uom: listData.uom }
      if (apiURI) {
        const result = await this.$http.get(expandURI(apiURI, expand))
        const { data } = result.data
        if (data) {
          this.uomForm.uom = data.UOM.uom
          this.uomForm.uomShortDesc = data.UOM.uomShortDesc
          this.uomForm.uomLongDesc = data.UOM.uomLongDesc
          this.uomForm.isExcess = data.UOM.isExcess
          this.uomForm.isSumInsured = data.UOM.isSumInsured
          this.uomForm.createdName = data.UOM.createdName
          this.uomForm.createdDate = data.UOM.createdDate
          this.uomForm.modifiedName = data.UOM.modifiedName
          this.uomForm.modifiedDate = data.UOM.modifiedDate

          this.mode = mode
          this.uomReview = true
        }
      }
    },
    doNew() {
      this.mode = 'new'
      this.uomReview = true
    },
    doClose() {
      this.uomReview = false
      this.doInit(false)
    },
    doRemoveValidation(data) {
      this.resetMessages()
      const apiURI = this.uomMenu.deleteUOMValidation
      if (apiURI) {
        const expand = data.item
        this.$http
          .post(apiURI, expand)
          .then((result) => {
            this.doAction('delete', data.item)
          })
          .catch((err) => {
            const { data } = err.response
            if (data) {
              this.message(data)
            }
          })
      }
    }
  },
  mounted() {
    this.doInit(true)
  },
  components: {
    UomReview
  },
  mixins: [TableConst.default, MessageMixin]
}
</script>

<style lang="scss">
</style>
